import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Ricerca in alto (Layout.js, Ricerca): al primo focus legge GET /api/projects e GET /api/grants (un errore vale []),
// poi filtra per nome (sottostringa, senza maiuscole) da 2 caratteri: al più 5 progetti e 5 bandi. Invio apre il primo
// risultato, Esc o un clic fuori chiudono. I bandi non visibili o non verificati non compaiono mai.
export default class extends Controller {
  static targets = ["campo", "risultati", "messaggio", "progetto", "bando"]

  connect() { this.dati = null; this.vista = [] }

  async carica() {
    this.mostra()
    if (this.dati || this.inCorso) return
    this.inCorso = true
    const [p, g] = await Promise.all([this.leggi("/api/projects"), this.leggi("/api/grants")])
    this.dati = {
      progetti: p,
      bandi: g.filter((b) => b.visibile !== false && (b.verificato ?? b.verifica?.stato === "verificato")),
    }
    this.inCorso = false
    this.mostra()
  }

  async leggi(url) {
    try {
      const res = await fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!res.ok) return []
      const dati = await res.json()
      return Array.isArray(dati) ? dati : []
    } catch { return [] }
  }

  digita() { this.mostra() }

  tasto(event) {
    if (event.key === "Enter" && this.vista[0]) this.apri(this.vista[0])
    if (event.key === "Escape") this.risultatiTarget.hidden = true
  }

  fuori(event) { if (!this.element.contains(event.target)) this.risultatiTarget.hidden = true }

  vai(event) {
    const riga = this.vista.find((r) => r.nodo === event.currentTarget)
    if (riga) this.apri(riga)
  }

  apri(riga) {
    this.risultatiTarget.hidden = true
    this.campoTarget.value = ""
    Turbo.visit(riga.to)
  }

  mostra() {
    const t = this.campoTarget.value.trim().toLowerCase()
    const box = this.risultatiTarget
    this.vista = []
    box.replaceChildren()
    if (t.length < 2) { box.hidden = true; return }
    box.hidden = false
    if (!this.dati) return this.messaggio("Caricamento…")
    const trova = (elenco) => elenco.filter((x) => (x.name || "").toLowerCase().includes(t)).slice(0, 5)
    const righe = [
      ...trova(this.dati.progetti).map((x) => ({ modello: this.progettoTarget, nome: x.name, to: `/app/progetto/${encodeURIComponent(x.id)}` })),
      ...trova(this.dati.bandi).map((x) => ({ modello: this.bandoTarget, nome: x.name, to: `/app/bandi?bando=${encodeURIComponent(x.id)}` })),
    ]
    if (righe.length === 0) return this.messaggio("Nessun progetto o bando con questo nome.")
    for (const r of righe) {
      const nodo = r.modello.content.firstElementChild.cloneNode(true)
      nodo.querySelector("[data-nome]").textContent = r.nome
      r.nodo = nodo
      box.append(nodo)
    }
    this.vista = righe
  }

  messaggio(testo) {
    const nodo = this.messaggioTarget.content.firstElementChild.cloneNode(true)
    nodo.textContent = testo
    this.risultatiTarget.append(nodo)
  }
}
